import React from 'react'
import { ReactSession }  from 'react-client-session';
import { useSelector } from 'react-redux';

type Props = {
    path?: string; // splitted by dot
}

const ContentLabel = ({path, ...props}:Props & React.HTMLAttributes<HTMLParagraphElement>) => {
    const content = useSelector((state:any) => state.content);
    const language = ReactSession.get("language");

    const keys = path?.split('.') || []

    // Traverse the object case-insensitively
    const getValueCaseInsensitive = (obj: any, keyPath: string[]) => {
        return keyPath.reduce((current: any, key: string) => {
            if (current && typeof current === 'object') {
                const foundKey = Object.keys(current).find(
                    k => k.toLowerCase() === key.toLowerCase()
                );
                return foundKey ? current[foundKey] : undefined;
            }
            return undefined;
        }, obj);
    };

    const label = getValueCaseInsensitive(content?.[language], keys);

    if(typeof label === 'string'){
        return <p {...props}>{label}</p>
    }
    else {
        return <p {...props}>{path}</p>
    }
}

export { ContentLabel }